exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".basic-bar-position[data-v-db4c0248]{-webkit-transform:translateX(-50%);transform:translateX(-50%)}", ""]);

// exports
